import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy alias — permanent server-side redirect so crawlers consolidate on /characters.
export const Route = createFileRoute("/meet/")({
  beforeLoad: () => {
    throw redirect({ to: "/characters", replace: true, statusCode: 301 });
  },
});
